import { useEffect } from 'react';

function labelFromHeader(header) {
  const copy = header.cloneNode(true);
  copy.querySelectorAll('button, svg, .sort-indicator').forEach((element) => element.remove());
  return copy.textContent.replace(/\s+/g, ' ').trim() || 'Field';
}

function labelTableCells(table) {
  const headers = Array.from(table.querySelectorAll('thead tr:last-child th'));
  if (headers.length === 0) return;

  const labels = headers.map(labelFromHeader);
  table.querySelectorAll('tbody tr').forEach((row) => {
    let columnIndex = 0;
    Array.from(row.children).forEach((cell) => {
      if (cell.tagName !== 'TD') return;

      const colspan = Number(cell.getAttribute('colspan')) || 1;
      if (colspan === 1 && labels[columnIndex]) {
        cell.dataset.mobileLabel = labels[columnIndex];
      } else {
        delete cell.dataset.mobileLabel;
      }
      columnIndex += colspan;
    });
  });
}

/** Keeps mobile-card labels synchronized with the headers of dynamic tables. */
export default function ResponsiveTableLabels() {
  useEffect(() => {
    const syncLabels = () => {
      document.querySelectorAll('table.mobile-cards').forEach(labelTableCells);
    };

    syncLabels();
    const observer = new MutationObserver(syncLabels);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
